var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3H10.5C11.052 3 11.5 2.552 11.5 2C11.5 1.448 11.052 1 10.5 1H2C1.47 1 0.960999 1.211 0.585999 1.586C0.210999 1.961 0 2.47 0 3V21C0 21.361 0.193996 21.693 0.507996 21.871C0.821996 22.048 1.20799 22.043 1.51599 21.856L8.5 17.644L15.484 21.856C15.792 22.043 16.178 22.048 16.492 21.871C16.806 21.693 17 21.361 17 21V8.5C17 7.948 16.552 7.5 16 7.5C15.448 7.5 15 7.948 15 8.5V19.229L9.01599 15.62C8.69899 15.428 8.30101 15.428 7.98401 15.62L2 19.229V3ZM15 2H14C13.448 2 13 2.448 13 3C13 3.552 13.448 4 14 4H15V5C15 5.552 15.448 6 16 6C16.552 6 17 5.552 17 5V4H18C18.552 4 19 3.552 19 3C19 2.448 18.552 2 18 2H17V1C17 0.448 16.552 0 16 0C15.448 0 15 0.448 15 1V2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.958e790175f36d1ce9e2b7fdd6076721.svg";
export { ForwardRef as ReactComponent };